import { render } from "./SingleClassAnnouncement.vue?vue&type=template&id=82394f90"
import script from "./SingleClassAnnouncement.vue?vue&type=script&lang=js"
export * from "./SingleClassAnnouncement.vue?vue&type=script&lang=js"

import "./SingleClassAnnouncement.vue?vue&type=style&index=0&id=82394f90&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__